import React, { useCallback, useState } from 'react';
import { css } from '@emotion/react';
import OutsideClickHandler from "react-outside-click-handler";

import ProfileContextMenu from "./ProfileContextMenu";
import theme from "../../theme";
import { useAppState } from "../contexts/AppContext";
import ProfileIcon from "./ProfileIcon";
import * as storage from "../includes/localStorage";

const Profile = () => {
    const [appState] = useAppState();
    const [isOpenContext, setIsOpenContext] = useState(false);

    const toggleMenu = useCallback((e: any, forceClose = false) => {
        if (!forceClose) return setIsOpenContext(!isOpenContext);
        setTimeout(() => isOpenContext && setIsOpenContext(false), 100);
    }, [isOpenContext]);

    const onOutsideClick = useCallback((e: any) => toggleMenu(e, true), [toggleMenu]);
    const user = appState.user;
    const socialAvatarUrl = user?.LastLoginType === "google" ? storage.retrieve("socialAvatarUrl") : null;

    if (!user) return null

    return (
        <div css={profileContainerStyle}>
            <div css={userProfileStyle}>
                <OutsideClickHandler display={"flex"} onOutsideClick={onOutsideClick}>
                    <div css={userProfileContentStyle} onClick={toggleMenu}>
                        {socialAvatarUrl
                            ? (<img css={profileIconStyle} src={socialAvatarUrl} alt="" />)
                            : (<ProfileIcon css={profileIconStyle} />)
                        }
                        {isOpenContext && <div css={selectorStyle} />}
                    </div>
                    <div css={textWithChevronWrapperStyle}>
                        {isOpenContext && (
                            <ProfileContextMenu />
                        )}
                    </div>
                </OutsideClickHandler>
            </div>
        </div>
    );
}

const profileContainerStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: ${theme.zIndex.zIndexHigher};
`;

const userProfileStyle = css`
    position: relative;
    display: flex;
    z-index: ${theme.zIndex.zIndexLow};
    justify-content: center;
    align-items: center;
    font-family: ${theme.fonts.frutiger};
    width: 68px;
    margin-right: 49px;
    height: 100%;
    
    > div {
        width: 100%;
    }
`;

const selectorStyle = css`
    position: absolute;
    width: 100%;
    height: 8px;
    background-color: ${theme.colours.curiousBlue};
    bottom: 0;
    border-radius: ${theme.borderAndShadow.smallRadius};
`;

const profileIconStyle = css`
    width: 43px;
    height: 43px;

    ${theme.breakpoints.only("xxl")} {
        width: 40px;
        height: 40px;
    }

    ${theme.breakpoints.only("xl")} {
        width: 37px;
        height: 37px;
    }
`;

const userProfileContentStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    position: relative;
    height: 86px;
    width: 100%;
    justify-content: center;
    transition: color ${theme.transitions.transition};
    :hover {
        background-color: ${theme.utils.rgba(theme.colours.alto, 0.35)};
    }
`;

const textWithChevronWrapperStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
        margin-top: 3px;
    }
`;


export default Profile;
